import React from 'react';
import { ShowIf } from 'components/utils';
import { API_URL } from 'constants/config';
import { Link } from 'react-router';
import ReactPaginate from 'react-paginate';
import { Button } from '@blueprintjs/core';
import moment from 'moment';
import classnames from 'classnames';
import { Input } from 'components/tt-forms/common';
import { downloadFile } from "constants/downloadFile";
import { get, isEmpty } from 'lodash';
import { Reception, ThanhTra } from 'api';
import { Toastr } from 'modules/toastr';
export default class DataTableDoiTuongThanhTra extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      export: 'btn-green tt-export',
      approved: 'btn-green tt-approve-double-check',
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      divHeight: 195,
      down: false,
      scrollLeft: '',
      x: ''
    };

  }

  componentWillReceiveProps(nextProps) {
    let divHeight = 0;
    let obj = document.getElementsByClassName('table-header')[0];

    if (obj && obj.offsetHeight) {
      divHeight = obj.offsetHeight;
    } else if (obj && obj.style && obj.style.pixelHeight) {
      divHeight = obj.style.pixelHeight;
    }
    this.setState({
      divHeight: divHeight + 2
    })
  }

  handleChangePageSize(size) {
    if (this.props.parent && this.props.parent.handleChangePageSize) {
      this.props.parent.handleChangePageSize.bind(this.props.parent, size);
    }
  }

  handlePageClick(page) {
    if (this.props.parent && this.props.parent.handlePageC1lick) {
      this.props.parent.handlePageClick.bind(this.props.parent, page);
    }
  }

  componentDidMount() {
    if (this.props.hideExport) {
      this.setState({
        export: 'btn-green tt-export disable'
      });
    }

    let divHeight = 0;
    let obj = document.getElementsByClassName('table-header')[0];

    if (obj && obj.offsetHeight) {
      divHeight = obj.offsetHeight;

    } else if (obj && obj.style.pixelHeight) {
      divHeight = obj.style.pixelHeight;

    }
    this.setState({
      divHeight: divHeight + 2
    })
  }

  handleExportExcel() {

    if (this.props.typeExport == 'TIEP_CONG_DAN') {

      if (this.props.parent.state.advanceSearch == true) {
        let startDate = this.props.parent.state.startDate ? moment(this.props.parent.state.startDate, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '';
        let endDate = this.props.parent.state.endDate ? moment(this.props.parent.state.endDate, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '';

        let URL = String(API_URL) + "/soTiepCongDans/excel?tuNgay=" + startDate
          + "&denNgay=" + endDate
          + "&loaiTiepCongDan=" + this.props.type
          + "&huongXuLy=" + (this.props.parent.state.handleRedirect ? this.props.parent.state.handleRedirect : '')
          + "&phanLoaiDon=" + this.props.parent.state.receptionType
          + "&coQuanQuanLyId=" + this.state.userInfo.donViId
          + "&lanhDaoId=" + (this.props.parent.state.lanhDaoTiepDan ? this.props.parent.state.lanhDaoTiepDan : '')
          + "&ketQuaTiepDan=" + (this.props.parent.state.ketQuaTiepDan ? this.props.parent.state.ketQuaTiepDan : '')
          + "&tinhTrangXuLy=" + (this.props.parent.state.tinhTrangXuLy ? this.props.parent.state.tinhTrangXuLy : '')
          + "&page=" + this.props.pageData.number
          + "&size=" + this.props.pageData.size
          + '&tuKhoa=' + this.props.parent.state.searchKey + ''
          + '&sort=' + this.props.sortBy;
        window.open(URL, "_self");
      } else {
        let URL = String(API_URL) + "/soTiepCongDans/excel?loaiTiepCongDan=" + this.props.type
          + "&coQuanQuanLyId=" + this.state.userInfo.donViId
          + "&page=" + this.props.pageData.number
          + "&size=" + this.props.pageData.size
          + '&sort=' + this.props.sortBy
          + '&tuKhoa=' + this.props.parent.state.searchKey;
        window.open(URL, "_self");
      }

    } else if (this.props.typeExport == 'XU_LY_DON') {

      let URL = String(API_URL) + "/dons/xuatExcel?donViXuLyXLD=" + this.state.userInfo.donViId
        + "&phongBanXuLyXLD=" + this.state.userInfo.coQuanQuanLyId
        + "&vaiTro=" + this.state.userInfo.loaiVaiTroMacDinh
        + "&canBoXuLyXLD=" + this.state.userInfo.id
        + "&page=" + this.props.pageData.number
        + "&size=" + this.props.pageData.size
        + "&thanhLapDon=true"
        + "&trangThaiDon=" + this.props.parent.state.trangThaiXuLyDon;

      if (this.props.sortBy) {
        URL = URL + "&sort=" + this.props.sortBy;
      }

      if (this.props.parent.state.advanceSearch) {

        if (this.props.searchData) {

          if (this.props.searchData.searchKey) {
            URL = URL + "&tuKhoa=" + this.props.searchData.searchKey;
          }

          if (this.props.searchData.startDate) {
            let startDate = moment(this.props.searchData.startDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
            URL = URL + "&tiepNhanTuNgay=" + startDate;
          }

          if (this.props.searchData.endDate) {
            let endDate = moment(this.props.searchData.endDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
            URL = URL + "&tiepNhanDenNgay=" + endDate;
          }

          if (this.props.searchData.maDon) {
            URL = URL + "&maDon=" + this.props.searchData.maDon;
          }

          if (this.props.searchData.nguonDon) {
            URL = URL + "&nguonDon=" + this.props.searchData.nguonDon;
          }

          if (this.props.searchData.phanLoaiDon) {
            URL = URL + "&phanLoaiDon=" + this.props.searchData.phanLoaiDon;
          }

          if (this.props.searchData.tinhTrangXuLy) {
            URL = URL + "&trangThaiDonToanHT=" + this.props.searchData.tinhTrangXuLy;
          }

          if (this.props.searchData.ketQuaXuLy) {
            URL = URL + "&ketQuaToanHT=" + this.props.searchData.ketQuaXuLy;
          }
        }
      } else {
        if (this.props.searchData && this.props.searchData.searchKey) {
          URL = URL + "&tuKhoa=" + this.props.searchData.searchKey;
        }
      }

      window.open(URL, "_self");
    } else if (this.props.typeExport == 'DS_YEU_CAU') {

      let URL = String(API_URL) + "/soTiepCongDans/danhSachYeuCauGapLanhDao/excel?donViId=" + this.state.userInfo.donViId;
      if (this.props.parent.state.tuKhoa) {
        URL = URL + "&tuKhoa=" + this.props.parent.state.tuKhoa;
      }
      if (this.props.sortBy) {
        URL = URL + "&sort=" + this.props.sortBy;
      }
      if (this.props.parent.state.advanceSearch) {

        if (this.props.parent.state.tuNgay) {
          let startDate = moment(this.props.parent.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
          URL = URL + "&tuNgay=" + startDate;
        }

        if (this.props.parent.state.denNgay) {
          let endDate = moment(this.props.parent.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
          URL = URL + "&denNgay=" + endDate;
        }

        if (this.props.parent.state.phanLoai) {
          URL = URL + "&phanLoai=" + this.props.parent.state.phanLoai;
        }

        if (this.props.parent.state.nguonDon) {
          URL = URL + "&nguonDon=" + this.props.parent.state.nguonDon;
        }

        if (this.props.parent.state.trangThai) {
          URL = URL + "&trangThai=" + this.props.parent.state.trangThai;
        }
      }

      downloadFile(URL);
    }
  }

  handleExport() {
    this.props.handleExport()
  }

  handleExportExampleKiemTra() {
    this.props.handleExportExampleKiemTra();
  }

  handleImportEmxampleKiemTra(e) {
    let params = {
      field: 'file', file: e.target.files[0]
    };
    Reception.actions.postFileUploadExcelData.request('', params).then(res => {
      this.props.handleImportEmxampleKiemTra(res);
    }).catch(error => {
      Toastr(get(error, 'response.data.errors[0].detail'), 'error');
    });
  }

  getItemTongSoThongKe() {
    const pageNumber = get(this.props.pageData, 'number') || 0;
    const pageSize = get(this.props.pageData, 'size') || 0;
    let dataSum = {}
    if (this.props.dataSum) {
      dataSum = { ...this.props.dataSum };
    }
    dataSum.donVi = {
      id: 'TONG_CONG',
      ten: 'Tổng cộng'
    }
    dataSum.ghiChu = '';
    return React.cloneElement(this.props.children, {
      count: (pageNumber * pageSize) + this.props.dataList.length + 1,
      item: dataSum,
      sum: true
    });
  }

  getItemTongDonTrung() {
    const pageNumber = get(this.props.pageData, 'number') || 0;
    const pageSize = get(this.props.pageData, 'size') || 0;
    let dataDonTrung = {};
    if (this.props.dataDonTrung) {
      dataDonTrung = { ...this.props.dataDonTrung };
    }
    dataDonTrung.donVi = {
      id: 'TONG_TRUNG',
      ten: 'Tổng Trùng'
    };
    dataDonTrung.ghiChu = '';
    return React.cloneElement(this.props.children, {
      count: (pageNumber * pageSize) + this.props.dataList.length + 1,
      item: dataDonTrung,
      sum: true
    });
  }

  getItemNull() {
    return (
      this.props.children
    )
  }

  handleDown(e) {
    if (this.props.touchMove) {
      let Item = document.getElementById('scrollItem');
      document.getElementById('scrollItem').classList.add("scrolling");
      this.state.down = true;
      this.state.scrollLeft = Item.scrollLeft;
      this.state.x = e.clientX;
    }
  }

  handleUp() {
    if (this.props.touchMove) {
      document.getElementById('scrollItem').classList.remove("scrolling");
      this.state.down = false;
    }
  }

  handleMove(e) {
    if (this.props.touchMove) {
      let Item = document.getElementById('scrollItem');
      if (this.state.down == true) {
        Item.scrollLeft = this.state.scrollLeft + this.state.x - e.clientX;
      }
    }
  }

  handleLeave() {
    if (this.props.touchMove) {
      document.getElementById('scrollItem').classList.remove("scrolling");
      this.state.down = false;
    }
  }

  onChange(index, e) {
    this.props.onChangeHeader(index, e);
  }

  addNewItem() {
    this.props.addNewItem();
  }

  addNewVanBanCanCu() {
    this.props.addNewVanBanCanCu();
  }

  handleApprove() {
    ThanhTra.actions.approveDoiTuongThanhTra.request('', {ids: this.props.doiTuongSelecteds}).then(res => {
      this.props.getListData();
      Toastr('Duyệt đối tượng thanh tra thành công', 'success');
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  render() {
    let pageNumber = this.props.pageData ? this.props.pageData.number : 0;
    let pageSize = this.props.pageData ? this.props.pageData.size : 0;
    let dataListItem = this.props.dataList.map((item, i) => {
      return (
        React.cloneElement(this.props.children, {
          key: i,
          count: (pageNumber * pageSize) + i + 1,
          item,
          parent: this.props.parent
        }))
    });

    var childrenNull = React.Children.map(this.props.children, child =>
      React.cloneElement(child, { nullElement: true }));

    let ItemLoading = (
      <div className="loading-content">
        <span className="shape1"></span>
        <span className="shape2"></span>
        <span className="shape3"></span>
        <span className="shape4"></span>
        <span className="shape5"></span>
        <span className="shape6"></span>
        <span className="shape7"></span>
        <span className="shape8"></span>
        <span className="shape9"></span>
        <span className="shape10"></span>
        <span className="shape11"></span>
        <span className="shape12"></span>
        <span className="shape13"></span>
      </div>
    )
    return (
      <div className={this.props.ThongKeBaoCao ? 'wrapper-table wrapper-tkbc' : 'wrapper-table'}>
        <ShowIf condition={this.props.ThongKeBaoCao}>
          <ShowIf condition={this.props.LapBaoCao == false}>
            <div className='header-table-wrap' style={{ height: this.state.divHeight }}>
              <div className='header-stt'>STT</div>
              <div className='header-name'>ĐƠN VỊ</div>
              <div className='header-ms'>MS</div>
              <ShowIf condition={!this.props.tableLoading}>
                <div className='value-column-fixed-wrap'>
                  {
                    this.props.dataList.map((item, i) => {
                      return (
                        <div className='fixed-column-wrap' key={i}>
                          <span className='tr-ghichu'>{item.ghiChu ? item.ghiChu : ''}</span>
                          <span className='tr-stt'>{i + 1}</span>
                          <span className='tr-name'>{item.donVi ? item.donVi.ten : (item.capDonVi ? item.capDonVi.ten : '')}</span>
                        </div>
                      )
                    })
                  }
                  <ShowIf condition={this.props.dataList.length > 1}>
                    {
                      this.props.showTongDonTrung &&
                      <div className='fixed-column-wrap sum'>
                        <span className='tr-sum-name'>Tổng đơn trùng</span>
                      </div>
                    }
                    <div className='fixed-column-wrap sum'>
                      <span className='tr-sum-name'>Tổng cộng</span>
                    </div>
                  </ShowIf>
                </div>
              </ShowIf>
            </div>
          </ShowIf>
          <ShowIf condition={this.props.LapBaoCao == true}>
            <div className='header-table-wrap' style={{ height: this.state.divHeight }}>
              <div className='header-stt'>STT</div>
              <div className='header-name'>ĐƠN VỊ</div>
              <div className='header-ms'>MS</div>
              <ShowIf condition={!this.props.tableLoading}>
                <div className='value-column-fixed-wrap'>
                  {
                    this.props.dataList.map((item, i) => {
                      if (item.donVi && item.donVi.id) {
                        return (
                          <div className='fixed-column-wrap' key={i}>
                            <span className='tr-ghichu tt-ghichu-has-bb'><Input className={`col-100 no-gutter mb0-18`} defaultvalue={item.ghiChu ? item.ghiChu : ''} /></span>
                            <span className={`tr-stt txt-bold ${item && item.laySoLieu == false && item.trangThaiBaoCao != 'DANG_SOAN' && item.trangThaiBaoCao != 'DA_GUI' ? '' : 'val-content-red'}`}>{i + 1}</span>
                            <span className={`tr-name txt-bold ${item && item.laySoLieu == false && item.trangThaiBaoCao != 'DANG_SOAN' && item.trangThaiBaoCao != 'DA_GUI' ? '' : 'val-content-red'}`}>{item.donVi ? item.donVi.ten : (item.capDonVi ? item.capDonVi.ten : '')}</span>
                          </div>
                        )
                      } else {
                        return (
                          <div className='fixed-column-wrap' key={i}>
                            <span className='tr-ghichu tt-ghichu-has-bb'><Input className='col-100 no-gutter mb0-18' defaultvalue={item.ghiChu ? item.ghiChu : ''} /></span>
                            <span className='tr-stt'>{i + 1}</span>
                            <span className='tr-name'><Input className='col-100 no-gutter mb0-18' triggeOnBlur={true} value={item.donVi ? item.donVi.ten : (item.capDonVi ? item.capDonVi.ten : '')} onChange={this.onChange.bind(this, i)} /></span>
                          </div>
                        )
                      }
                    })
                  }
                  <ShowIf condition={this.props.addNew == true}>
                    <div className='fixed-column-wrap sum'>
                      <span className='tr-sum-name txt-blue pointer' onClick={this.addNewItem.bind(this)}><i className='tt tt-addfile tt-custom' />Thêm mới đơn vị</span>
                    </div>
                  </ShowIf>
                  <ShowIf condition={this.props.dataList.length > 1}>
                    {
                      this.props.showTongDonTrung &&
                      <div className='fixed-column-wrap sum'>
                        <span className='tr-sum-name'>Tổng đơn trùng</span>
                      </div>
                    }
                    <div className='fixed-column-wrap sum'>
                      <span className='tr-sum-name'>Tổng cộng</span>
                    </div>
                  </ShowIf>
                </div>
              </ShowIf>
            </div>
          </ShowIf>
        </ShowIf>
        {
          this.props.displayCount ?
            <div className="tc-total">
              Có <span>{this.props.pageData.totalElements}</span> kết quả tìm kiếm phù hợp với yêu cầu
            </div>
            : ''
        }
        <div
          className={classnames('table-container', {
            'touch-move': this.props.touchMove,
            'checktracuu': this.props.checkTraCuu,
            'checktdgs': this.props.checkTDGS
          })}
          id='scrollItem'
          onMouseUp={this.handleUp.bind(this)}
          onMouseDown={this.handleDown.bind(this)}
          onMouseMove={this.handleMove.bind(this)}
          onMouseLeave={this.handleLeave.bind(this)}
        >
          <table className="table-content">
            <ShowIf condition={!this.props.ThongKeBaoCao}>
              <thead className="table-header">
                <tr>
                  <ShowIf condition={this.props.showCheckbox && this.props.isTTTP}>
                    <th className="table-header-col table-checkbox" style={{ width: 40 }}>
                      <label className="pt-control pt-checkbox pt-large">
                        <input type="checkbox" className="pt-large" name="" onChange={this.props.onCheck.bind(this)} checked={this.props.selectAllStatus} disabled={this.props.isDisabledCheckAll} />
                        <span className="pt-control-indicator"></span>
                      </label>
                    </th>
                  </ShowIf>
                  {this.props.header.map((item, i) => {
                    return (
                      <th key={i} className={"table-header-col " + (item.className ? item.className : '')} colSpan={item.colSpan} style={{ width: item.width, minWidth: item.minWidth }}>
                        {item.name}
                      </th>
                    );
                  })}
                </tr>
              </thead>
            </ShowIf>
            <ShowIf condition={this.props.ThongKeBaoCao}>
              <thead className="table-header">
                {
                  this.props.header.map((headerItems, i) => {
                    let items = [];
                    items = [...headerItems]
                    return (
                      <tr key={i}>
                        {
                          items.map((item, j) => {
                            return (
                              <th key={j} className={"table-header-col " + (item.className ? item.className : '')} colSpan={item.colSpan} rowSpan={item.rowSpan} style={{ maxWidth: item.maxWidth, width: item.width, minWidth: item.minWidth }}>
                                {item.name}
                              </th>
                            );
                          })
                        }
                        <ShowIf condition={this.props.lapBaoCaoTongHop == true && i == 0}>
                          <th className="table-header-col middle-content" colSpan={1} rowSpan={this.props.header.length} style={{ width: 120, minWidth: 120 }}>THAO TÁC</th>
                        </ShowIf>
                      </tr>
                    );
                  })
                }
                <tr>
                  {
                    Array.from(Array(this.props.numberColumnHeader).keys()).map((item, i) => {
                      return (
                        <th className='txt-center' key={i}>{item - 1}</th>
                      )
                    })
                  }
                </tr>
              </thead>
            </ShowIf>
            {this.props.tableLoading ? (
              <tbody className="table-body">
                <tr className="table-loading">
                  <ShowIf condition={!this.props.ThongKeBaoCao}>
                    <td colSpan={this.props.header.length}>
                      {ItemLoading}
                      {ItemLoading}
                      {ItemLoading}
                      {ItemLoading}
                      {ItemLoading}
                      {ItemLoading}
                      {ItemLoading}
                      {ItemLoading}
                      {ItemLoading}
                      {ItemLoading}
                      {ItemLoading}
                      {ItemLoading}
                    </td>
                  </ShowIf>
                  <ShowIf condition={this.props.ThongKeBaoCao}>
                    <td colSpan={this.props.numberColumnHeader}>
                      {ItemLoading}
                      {ItemLoading}
                      {ItemLoading}
                    </td>
                  </ShowIf>
                </tr>
              </tbody>
            ) : (
              <tbody className="table-body">
                {dataListItem}

                {/*rowitem cho button thêm mới đơn vị*/}
                {
                  this.props.ThongKeBaoCao == true && this.props.LapBaoCao == true && this.props.addNew == true ? (childrenNull) : null
                }

                {/*tổng số thống kê*/}
                <ShowIf condition={this.props.ThongKeBaoCao && this.props.dataList.length > 1 && this.props.showTongDonTrung}>
                  {this.getItemTongDonTrung()}
                </ShowIf>
                <ShowIf condition={this.props.ThongKeBaoCao && this.props.dataList.length > 1}>
                  {this.getItemTongSoThongKe()}
                </ShowIf>

                <ShowIf condition={this.props.dataList.length == 0 && !this.props.showAddMore && this.props.search == true && !this.props.ThongKeBaoCao}>
                  <tr>
                    <td colSpan={this.props.header.length + this.props.plusColum}>Không có dữ liệu</td>
                  </tr>
                </ShowIf>

                <ShowIf condition={this.props.dataList.length == 0 && !this.props.showAddMore && this.props.search == false && !this.props.ThongKeBaoCao}>
                  <tr>
                    <td colSpan={this.props.header.length + this.props.plusColum}>{this.props.emptyMsg}</td>
                  </tr>
                </ShowIf>

                <ShowIf condition={this.props.dataList.length == 0 && !this.props.showAddMore && this.props.search == true && this.props.ThongKeBaoCao}>
                  <tr>
                    <td colSpan={this.props.numberColumnHeader}>Không có dữ liệu</td>
                  </tr>
                </ShowIf>

                <ShowIf condition={this.props.dataList.length == 0 && !this.props.showAddMore && this.props.search == false && this.props.ThongKeBaoCao}>
                  <tr>
                    <td colSpan={this.props.numberColumnHeader}>Chưa có dữ liệu</td>
                  </tr>
                </ShowIf>

                <ShowIf condition={this.props.showAddMore == true}>
                  <tr>
                    <td className="multipe-column" colSpan={this.props.header.length}>
                      <Link className="btn-addfile itt-Them-Moi" onClick={this.props.addMore}>
                        {this.props.titleAddmore}
                      </Link>
                    </td>
                  </tr>
                </ShowIf>
                {
                  this.props.thongKeDonCu &&
                  <tr>
                    <td colSpan={2} className='txt-left'><span className='title-12'>Tổng đơn</span></td>
                    <td className="black-val">{this.props.tongSoDonDonGian}</td>
                    <td className="black-val">{this.props.tongSoDonPhucTap}</td>
                    <td className="black-val">{this.props.tongSoDon}</td>
                  </tr>
                }
                {
                  this.props.isTableCanCuCuocThanhTra && (
                    <tr>
                      <td className="multipe-column" colSpan={this.props.header.length}>
                        <Link className="btn-addfile itt-Them-Moi" onClick={this.addNewVanBanCanCu.bind(this)}>
                          Thêm mới văn bản
                        </Link>
                      </td>
                    </tr>
                  )
                }
              </tbody>
            )}
          </table>
          {!this.props.hidePagination && this.props.dataList.length > 0 && !this.props.ThongKeBaoCao ? (
            <div className="pagination-wrap">
              <ShowIf condition={!isEmpty(this.props.doiTuongSelecteds) && this.props.isTTTP}>
                <Button className={this.state.approved} text='Duyệt đối tượng' onClick={this.handleApprove.bind(this)} />
              </ShowIf>
              <ShowIf condition={this.props.thanhTra || !this.props.hideButtonExport}>
                <Button className={this.state.export} text={this.props.exporttext} onClick={this.handleExport.bind(this)} />
              </ShowIf>
              {!this.props.hideButtonExport ? (
                <Button className={this.state.export} text={this.props.exporttext} onClick={this.handleExportExcel.bind(this)} />
              ) : <div></div>}
              {(this.props.pageData && this.props.pageData.totalElements && this.props.pageData.totalElements > this.props.pageData.size) ?
                <ReactPaginate
                  pageCount={this.props.pageData ? this.props.pageData.totalPages : 1}
                  marginPagesDisplayed={1} pageRangeDisplayed={2} previousLabel={"<"} nextLabel={">"}
                  breakLabel={<a href="javascript:void(0)">...</a>} breakClassName={"item"}
                  onPageChange={this.props.parent.handlePageClick.bind(this.props.parent)}
                  containerClassName={"pagination-list"} pageClassName={'item'}
                  subContainerClassName={"pages pagination"} previousClassName={'item'}
                  nextClassName={'item'} activeClassName={"active"}
                  forcePage={this.props.pageData ? this.props.pageData.number : 0} />
                : null}
              {`(${(pageNumber * pageSize) + 1}-${this.props.pageData.totalElements < ((pageNumber + 1) * pageSize) ? this.props.pageData.totalElements : (pageNumber + 1) * pageSize}/${this.props.pageData.totalElements}) Trên 1 trang: `}
              <Link className={this.props.pageData.size == 10 ? 'disable-page' : 'page-number'} onClick={this.props.parent.handleChangePageSize.bind(this.props.parent, 10)}>10</Link>,
              <Link className={this.props.pageData.size == 25 ? 'disable-page' : 'page-number'} onClick={this.props.parent.handleChangePageSize.bind(this.props.parent, 25)}>25</Link>,
              <Link className={this.props.pageData.size == 50 ? 'disable-page' : 'page-number'} onClick={this.props.parent.handleChangePageSize.bind(this.props.parent, 50)}>50</Link>
            </div>
          ) : null}
          {this.props.isKiemTra && (
            <div className='wrap-import-kiem-tra'>
              <div className="download_file_content pt10 download-example-file" onClick={this.handleExportExampleKiemTra.bind(this)}>
                <span>Tải file import mẫu</span>
              </div>
              {/* <Link className="btn-orange" onClick={this.handleImportEmxampleKiemTra.bind(this)}><i className="tt tt-document-import"></i>Import đối tượng kiểm tra</Link> */}
              <div className="wrap-input-tt-dvph">
                <div className="upload_file_content pt10">
                  <input accept='.xls, .xlsx' type="file" name="uploadFile" className="upload btn-green btn-pullleft" ref='btnUpload' onChange={this.handleImportEmxampleKiemTra.bind(this)} />
                  {/* <span htmlFor="file">Import cuộc kiểm tra</span> */}
                  <Link htmlFor="file" className="btn-orange" onClick={this.handleImportEmxampleKiemTra.bind(this)}><i className="tt tt-document-import"></i>Import cuộc kiểm tra</Link>
                </div>
              </div>
            </div>
          )}
        </div>
        {
          this.props.ThongKeBaoCao && !this.props.hideExport ?
            (<div className="pagination-wrap">
              <Button className={this.state.export} text={this.props.exporttext} onClick={this.handleExport.bind(this)} />
            </div>)
            : (null)
        }
      </div>
    );
  }
}
DataTableDoiTuongThanhTra.defaultProps = {
  onChangeHeader: function () {
  },
  type: 'THUONG_XUYEN',
  labelPagination: 'Số hồ sơ',
  showAddMore: false,
  typeExport: 'TIEP_CONG_DAN',
  titleAddmore: 'Thêm mới',
  ThongKeBaoCao: false,
  LapBaoCao: false,
  addNew: false,
  addNewItem: function () {},
  dataList: [],
  header: [],
  plusColum: 0,
  displayCount: false,
  emptyMsg: 'Chưa có dữ liệu'
}



// WEBPACK FOOTER //
// ./src/components/modules/category/datatable/list/DataTableDoiTuongThanhTra.jsx